import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Four04 } from 'gossamer-front-end';
import { OrgUnitCreate } from './OrgUnitCreate';
import { OrgUnitDisplay } from './OrgUnitDisplay';
import { OrgUnitSearch } from './OrgUnitSearch';
import { OrgUnitUpdate } from './OrgUnitUpdate';

export const OrgUnitRoutes = (): React.JSX.Element => (
  <Routes>
    <Route path="/create" element={<OrgUnitCreate />} />
    <Route path="/display/:key" element={<OrgUnitDisplay />} />
    <Route path="/search" element={<OrgUnitSearch />} />
    <Route path="/update/:key" element={<OrgUnitUpdate />} />
    <Route path="*" element={<Four04 />} />
  </Routes>
);
